<template>
  <v-container fluid class="novedades-view ui-module-fade-in-up">
    <v-card class="ui-module-card ui-module-fade-in-up novedades-shell" flat>
      <v-card-text class="novedades-content">
        <v-row class="toolbar-row" justify="end" align="center">
          <v-col cols="auto" class="d-flex align-center justify-end toolbar-register-col">
            <v-btn
              class="secondary register-btn ui-module-btn-solid py-2 px-8"
              rounded
              elevation="8"
              @click="openRegistroDialog()"
            >
              Registrar novedad
              <v-icon small class="ml-2 register-btn-icon">mdi-plus</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="auto" class="d-flex align-center justify-end toolbar-search-col">
            <v-text-field
              class="search-input"
              v-model="search"
              color="secondary"
              background-color="primary"
              rounded
              filled
              hide-details
              placeholder="Buscar novedad..."
              append-icon="mdi-magnify"
              clearable
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-data-table
              :headers="headers"
              :items="novedades"
              :search="search"
              class="card ui-module-card ui-module-table novedades-table"
              color="primary"
              :loading="loading"
              loading-text="Cargando novedades..."
              no-data-text="No hay novedades registradas."
              no-results-text="No se encontraron novedades con esa búsqueda."
              :footer-props="{ 'items-per-page-text': 'Filas por página' }"
            >
              <template #[`item.fk_idCatTipoNovedad`]="{ item }">
                {{ tipoNovedadLabel(item.fk_idCatTipoNovedad) }}
              </template>
              <template #[`item.actions`]="{ item }">
                <v-btn
                  icon
                  color="secondary"
                  class="edit-action ui-module-icon-action"
                  :loading="loadingEditarNovedad === item.id"
                  @click="openEditarDialog(item)"
                >
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <registro-novedad-dialog-component :active="registroDialog" @close="closeRegistroDialog()" />

    <editar-novedad-dialog-component :active="editarDialog" :novedad="selectedNovedad" @close="closeEditarDialog()" />
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import RegistroNovedadDialogComponent from '@/components/enlace/RegistroNovedadDialogComponent.vue'
import EditarNovedadDialogComponent from '@/components/enlace/EditarNovedadDialogComponent.vue'

export default {
  components: {
    RegistroNovedadDialogComponent,
    EditarNovedadDialogComponent,
  },

  async mounted() {
    this.loading = true
    await Promise.all([this.fetchNovedades(), this.fetchTiposNovedad()])
    this.loading = false
  },

  data() {
    return {
      search: '',
      loading: false,
      loadingEditarNovedad: false,
      registroDialog: false,
      editarDialog: false,
      selectedNovedad: null,

      headers: [
        { text: 'Tipo de novedad', value: 'fk_idCatTipoNovedad', sortable: true },
        { text: 'Fecha', value: 'fecha', sortable: true },
        { text: 'CUIP', value: 'usuario', sortable: true },
        { text: 'Descripción', value: 'descripcion', sortable: false },
        { text: 'Acciones', value: 'actions', sortable: false, align: 'center' },
      ],
    }
  },

  computed: {
    ...mapGetters('novedad', ['getNovedades']),
    ...mapGetters('tipoNovedad', ['getTiposNovedad']),

    novedades() {
      return this.getNovedades
    },
  },

  methods: {
    ...mapActions('novedad', ['fetchNovedades']),
    ...mapActions('tipoNovedad', ['fetchTiposNovedad']),

    tipoNovedadLabel(id) {
      const tipo = this.getTiposNovedad.find((t) => t.id === id)
      return tipo ? tipo.title : id
    },

    openRegistroDialog() {
      this.registroDialog = true
    },

    closeRegistroDialog() {
      this.registroDialog = false
    },

    async openEditarDialog(novedad) {
      this.loadingEditarNovedad = novedad.id
      await this.$nextTick()
      this.loadingEditarNovedad = false
      this.selectedNovedad = novedad
      this.editarDialog = true
    },

    closeEditarDialog() {
      this.editarDialog = false
      this.selectedNovedad = null
    },
  },
}
</script>

<style scoped>
.novedades-shell {
  background: transparent !important;
  border: 0 !important;
  box-shadow: none !important;
}

.novedades-content {
  padding: 20px !important;
}

.toolbar-row {
  margin-bottom: 4px;
}

.toolbar-search-col {
  width: 360px;
  max-width: 360px;
  flex: 0 0 360px;
}

::v-deep .toolbar-search-col .v-input {
  width: 100%;
  margin-top: 0 !important;
}

.register-btn {
  box-shadow: 0 10px 26px rgba(var(--v-secondary-base-rgb, 69, 170, 242), 0.34) !important;
}

.register-btn-icon {
  color: #17212d !important;
}

::v-deep .search-input .v-input__slot {
  background: rgba(8, 14, 19, 0.52) !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb, 69, 170, 242), 0.2) !important;
  border-radius: 14px !important;
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.2) !important;
}

::v-deep .search-input .v-label,
::v-deep .search-input input,
::v-deep .search-input .v-icon {
  color: #e0f0ff !important;
}

::v-deep .search-input.v-input--is-focused .v-input__slot {
  border-color: var(--v-secondary-base) !important;
  box-shadow: 0 0 0 2px rgba(var(--v-secondary-base-rgb, 69, 170, 242), 0.16) !important;
}

@media (max-width: 960px) {
  .toolbar-search-col {
    width: 100%;
    max-width: 100%;
    flex: 1 1 100%;
  }
}
</style>
